var _desc, _rect, _circle, _circle2, _rect2, _rect3, _circle3, _ellipse, _ellipse2, _ellipse3, _circle4, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlogReactNextjs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 700",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "React and Next.js comparison illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Two development panels comparing app and SEO-focused website architecture.")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 700,
    fill: "#07111f"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 350,
    r: 230,
    fill: "#38bdf8",
    opacity: 0.12
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 910,
    cy: 350,
    r: 230,
    fill: "#14b8a6",
    opacity: 0.12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 125,
    width: 455,
    height: 450,
    rx: 32,
    fill: "#0f172a",
    stroke: "#38bdf8",
    strokeWidth: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 645,
    y: 125,
    width: 455,
    height: 450,
    rx: 32,
    fill: "#0f172a",
    stroke: "#14b8a6",
    strokeWidth: 4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 328,
    cy: 255,
    r: 74,
    fill: "none",
    stroke: "#38bdf8",
    strokeWidth: 12
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 328,
    cy: 255,
    rx: 130,
    ry: 44,
    fill: "none",
    stroke: "#38bdf8",
    strokeWidth: 10
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 328,
    cy: 255,
    rx: 130,
    ry: 44,
    fill: "none",
    stroke: "#38bdf8",
    strokeWidth: 10,
    transform: "rotate(60 328 255)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 328,
    cy: 255,
    rx: 130,
    ry: 44,
    fill: "none",
    stroke: "#38bdf8",
    strokeWidth: 10,
    transform: "rotate(120 328 255)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 328,
    cy: 255,
    r: 18,
    fill: "#38bdf8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M760 200h220v115H760zM815 370h110M790 420h160M760 470h220",
    fill: "none",
    stroke: "#14b8a6",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M190 420h275M190 468h210M735 532h290M190 532h275",
    stroke: "#cbd5e1",
    strokeWidth: 15,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogReactNextjs);
export default __webpack_public_path__ + "static/media/blog-react-nextjs.1226f46c602dd9914bd5a8f051863be1.svg";
export { ForwardRef as ReactComponent };